<!--
    描述：提现记录
    时间：2020/11/3
    Created by 张磊
-->
<template>
	<div class="h100 withdrawal-record">
		<filter-layout
			@search="searchResult"
			@reset="reset"
			hasMore
			v-if="!routeQuery">
			<template #filter>
				<el-form
					class="flex-row-form colspan-4"
					size="small"
					ref="searchRef"
					label-width="110px"
					:model="searchForm">
					<el-form-item label="订单编号：" prop="orderNo">
						<el-input
							v-model="searchForm.orderNo"
							placeholder="请输入"
							size="small"></el-input>
					</el-form-item>
					<el-form-item label="商品名称：" prop="goodName">
						<el-input
							v-model="searchForm.goodName"
							placeholder="请输入"
							size="small">
						</el-input>
					</el-form-item>
					<el-form-item label="联系人：" prop="collectLink">
						<el-input
							v-model="searchForm.collectLink"
							placeholder="请输入"
							size="small">
						</el-input>
					</el-form-item>
					<el-form-item label="分账记录时间：" prop="dateRange">
						<el-date-picker
							v-model="searchForm.dateRange"
							type="daterange"
							size="small"
							value-format="yyyy-MM-dd"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form
					class="flex-row-form colspan-4"
					size="small"
					ref="searchRef"
					label-width="110px"
					:model="searchForm">
					<el-form-item label="收款公司：" prop="collectTenant">
						<el-input
							v-model="searchForm.collectTenant"
							placeholder="请输入"
							size="small">
						</el-input>
					</el-form-item>
					<el-form-item label="收款账户：" prop="collectAccount">
						<el-input
							v-model="searchForm.collectAccount"
							placeholder="请输入"
							size="small">
						</el-input>
					</el-form-item>
					<el-form-item label="收款账号：" prop="collectNo">
						<el-input
							v-model="searchForm.collectNo"
							placeholder="请输入"
							size="small">
						</el-input>
					</el-form-item>
					<el-form-item label="开户行：" prop="collectBank">
						<el-input
							v-model="searchForm.collectBank"
							placeholder="请输入"
							size="small">
						</el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<div class="content-header">
					<div class="title">
						待分账明细合计：<span class="blue">{{ tablePage.total }}</span> 条
					</div>
					<div class="toolbar">
						<el-button type="primary" size="mini" plain @click="doExport">数据导出</el-button>
						<el-button
							type="primary"
							class="btn-blue ml10"
							icon="el-icon-refresh"
							@click="reset"
							size="small">
						</el-button>
					</div>
				</div>
				<div class="w-table-layout w-table-page">
					<div class="w-table-content" v-show="tableShow" ref="table">
						<vxe-table
							ref="xTable"
							:data="tableData"
							highlight-current-row
							highlight-hover-row
							border
							height="100%"
							size="small"
							auto-resize
							resizable
							show-overflow="tooltip"
							show-header-overflow="tooltip">
							<vxe-table-column
								type="seq"
								title="序号"
								width="55px"
								align="center">
							</vxe-table-column>
							<vxe-table-column
								field="goodName"
								title="商品名称"
								width="210px"
								header-align="center">
							</vxe-table-column>
							<vxe-table-column
								field="merAmName"
								title="名义分账金额"
								width="120px"
								header-align="center"
								align="right">
								<!-- <template v-slot="{ row }">
									<span>{{ row.amount ? parseFloat(row.amount).toFixed(2) : "0.00" }}</span>
								</template> -->
							</vxe-table-column>
							<vxe-table-column
								field="orderAmName"
								title="商品总额"
								width="120px"
								header-align="center"
								align="right">
								<!-- <template v-slot="{ row }">
									<span>{{row.actualAmount ? parseFloat(row.actualAmount).toFixed(2) : "0.00" }}</span>
								</template> -->
							</vxe-table-column>
							<vxe-table-column
								field="ratioName"
								title="分账比例"
								width="120px"
								header-align="center"
								align="right">
							</vxe-table-column>
							<vxe-table-column
								field="recordDate"
								title="分账记录时间"
								width="180px"
								header-align="center">
							</vxe-table-column>
							<vxe-table-column
								field="orderNo"
								title="订单编号"
								width="180px"
								header-align="center">
							</vxe-table-column>
							<vxe-table-column
								field="collectTenant"
								title="收款公司"
								width="180px"
								header-align="center">
							</vxe-table-column>
							<vxe-table-column
								field="collectAccount"
								title="收款账户"
								width="180px"
								header-align="center">
							</vxe-table-column>
							<vxe-table-column
								field="collectNo"
								title="收款账号"
								width="180px"
								header-align="center">
							</vxe-table-column>
							<vxe-table-column
								field="collectBank"
								title="开户行"
								width="180px"
								header-align="center">
							</vxe-table-column>
							<vxe-table-column
								field="collectLink"
								title="联系人"
								width="120px"
								align="center">
							</vxe-table-column>
							<vxe-table-column
								field="taxNo"
								title="税号"
								width="180px"
								align="center">
							</vxe-table-column>
						</vxe-table>
					</div>
					<div class="w-table-footer">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="tablePage.currentPage"
							:page-size="tablePage.pageSize"
							:page-sizes="[10, 20, 50, 100]"
							layout="total, sizes, prev, pager, next, jumper"
							:total="tablePage.total"
						>
						</el-pagination>
					</div>
				</div>
			</template>
		</filter-layout>
	</div>
</template>
<script>
import {getPageSubs} from "api/modules/order-management.js";
import {mapState} from "vuex";
import XEUtils from "xe-utils";
import { exportPlus } from "utils/tools";
export default {
	name: 'Withdrawal-record',
	props: {},
	data() {
		return {
			searchForm: {
				orderNo: '', //订单编号
				goodName: '', // 商品名称
				collectLink: '', // 联系人
				collectTenant: '', //收款公司
				collectAccount: '', //收款账户
				collectNo: '', // 收款账号
				collectBank: '', //开户行
				dateRange: [], // 日期范围
			},

			tableData: [],
			tablePage: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			loading: false,
			searchToggle: true,
			tableShow: true,
			currentRow: {}, // 当前选择的行数据
		}
	},
	created() {
		this.selectSubList(true)
	},
	methods: {
		// 获取所有的流水数据
		selectSubList(isFirst) {
			let params = Object.assign({}, this.searchForm)
			params.current = this.tablePage.currentPage
			params.size = this.tablePage.pageSize
			params.createUser = this.userInfo.sname
			params.startDate = params.dateRange[0]? params.dateRange[0] + ' 00:00:00' : ''
			params.endDate = params.dateRange[1]? params.dateRange[1] + ' 23:59:59' : ''
			getPageSubs(params).then((d) => {
				if (d.operationCode == 1) {
					this.tableData = d.data.records
					this.tablePage.total = parseInt(d.data.total)
					// 刷新时 查看详细数据
					if (isFirst && this.$route.query.rowId) {
						let _row = this.tableData.find((y) => y.id === this.$route.query.rowId)
						_row ? (this.currentRow = _row) : ''
					}
				}
			})
		},
		//导出
		doExport() {
			let search = XEUtils.clone(this.searchForm, true)
			const params = {
				...search
			}
			params.startDate = params.dateRange[0]? params.dateRange[0] + ' 00:00:00' : ''
			params.endDate = params.dateRange[1]? params.dateRange[1] + ' 23:59:59' : ''
			delete params.dateArr
			exportPlus('/ngsOrder/exportSubList', params)
		},
		// 搜索
		searchResult() {
			this.tablePage.currentPage = 1
			this.tablePage.pageSize = 10
			this.selectSubList()
		},

		// 重置
		reset() {
			this.tablePage.currentPage = 1
			this.tablePage.pageSize = 10
			this.searchForm.goodName = ''
			this.searchForm.orderNo = ''
			this.searchForm.collectLink = ''
			this.searchForm.collectTenant = ''
			this.searchForm.collectAccount = ''
			this.searchForm.collectNo = ''
			this.searchForm.collectBank = ''
			this.searchForm.dateStart = ''
			this.searchForm.dateEnd = ''
			this.searchForm.dateRange = []
			this.selectSubList()
		},

		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tablePage.pageSize = size
			this.selectSubList()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tablePage.currentPage = cur
			this.selectSubList()
		},
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},
	},
}
</script>
<style lang="less" scoped>
.withdrawal-record {
	//.el-form {
	//	border-bottom: 1px solid #2671cc;
	//}
	.content-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;

		.title {
			padding-left: 10px;
			border-left: 4px solid #2671cc;
			font-size: 14px;
			color: #202020;
		}

		.blue {
			font-size: 18px;
			color: #2671cc;
		}
	}

	.btn-style {
		width: 80px;
		height: 32px;
	}

	.btn-blue {
		background-color: #2671cc !important;
		color: #fff;
	}

	.operation-header {
		display: block;
		line-height: 40px;

		.number-toolbar {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.number {
				padding-left: 10px;
				border-left: 4px solid #2671cc;
				height: 30px;
				line-height: 30px;

				span {
					color: #2671cc;
					font-size: 18px;
				}
			}
		}
	}

	.operation-container {
		height: calc(~'100% - 52px') !important;
	}

	/deep/ .vxe-cell--title {
		color: #202020;
		font-size: 14px;
		font-weight: normal;
	}

	.money-detail {
		font-size: 14px;
		padding: 30px 50px 0 50px;
		height: calc(~'100% - 50px');
	}

	.mb10 {
		margin-bottom: 10px !important;
	}

	.success-icon:before {
		content: '';
		display: inline-block;
		width: 10px;
		height: 10px;
		background-color: #13a919;
		border-radius: 50%;
		margin-right: 7px;
	}

	.error-icon:before {
		content: '';
		display: inline-block;
		width: 10px;
		height: 10px;
		background-color: #ff2313;
		border-radius: 50%;
		margin-right: 7px;
	}

	.success-text {
		color: #13a919;
		font-size: 16px;
		font-weight: 700;
	}

	.error-text {
		color: #ff2313;
		font-size: 16px;
		font-weight: 700;
	}
}

.bgc {
	background-color: #fff;
}
</style>

<style lang="less" scoped>
/deep/ .el-date-editor .el-range-separator {
	min-width: 25px;
}

</style>
